import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";

export default function TabLocal({ app, menuItemsStrings, ExportChartFootnote }) {
  return (
    <div className="container-fluid page-default fillpage-body" >
      <div className="row justify-content-start fillpage-row">

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 fillpage-col">

          {/* TOP band — KPIs (fixed) + charts (fill) */}
          <div className="band band-top">

            {/* Charts row (top) — fills the rest of the top band */}
            <div className="row justify-content-left band-charts">

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 d-flex flex-column">
                <div className="row justify-content-center h-100">
                  <div className="col-12 d-flex flex-column">
                    {/* map chart */}
                    <QlikCard
                      id="bRpnMHB"
                      height="100%"
                      showHeader={true}
                      showMaximize={true}
                      showExport={false}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if (exportType in { pdf: true, image: true } && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if (exportType in { pdf: true, image: true })
                          vis.setOptions({ showTitles: true, footnote: "" });
                      }}
                      exportText={menuItemsStrings.exportText}
                      exportCompletedText={menuItemsStrings.exportCompletedText}
                      closeBtnText={menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>
                </div>
                <div className="chart-extra justify-content-center">
                  <div className="col-12 col-xl-8 mx-auto">
                    <QlikCard
                      id="dkqLVjX"
                      height="32px"
                      showHeader={false}
                      showMaximize={false}
                      showExport={false}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5   d-flex flex-column">
                <div className="row justify-content-center h-100">
                  <div className="col-12 d-flex flex-column">
                    {/* bar chart */}
                    <QlikCard
                      id="79948f4a-2bc3-4edd-90a5-c2d605dd2d4b"
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if (exportType in { pdf: true, image: true } && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if (exportType in { pdf: true, image: true })
                          vis.setOptions({ showTitles: false, footnote: "" });
                      }}
                      exportText={menuItemsStrings.exportText}
                      exportCompletedText={menuItemsStrings.exportCompletedText}
                      closeBtnText={menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                      noSelections
                    />
                  </div>
                </div>
                <div className="chart-extra" style={{ height: "40px" }}></div>
              </div>
            </div>

          </div>

          {/* BOTTOM band — second charts row (fills the band) */}
              <div className="band band-bottom band-fill">
                <QlikCard
                  id="0572adc0-8acd-4b29-8325-d2ed6243f0bf"
                  height="100%"
                  showHeader={true}
                  showMaximize={true}
                  showExport={true}
                  onBeforeExportHandler={async ({  }) => {
                      await app.variable.setStringValue('export_link', '1');
                  }}
                  onAfterExportHandler={async ({  }) => {
                      app.variable.setStringValue('export_link', '0');
                  }}
                  exportText = {menuItemsStrings.exportText}
                  exportCompletedText = {menuItemsStrings.exportCompletedText}
                  closeBtnText = {menuItemsStrings.closeBtnText}
                  exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                  exportNoObjectText={menuItemsStrings.exportNoObjectText}
                  actionsVisibility="always"
                  copyCells="true"
                  copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
                  copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
                />
              </div>

        </div>


        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing fillpage-col">

          {/* TOP band — FilterPane (mirrors KPIs + charts band) */}
          <div className="band band-top filter-col">
            <div className="filter-overview-local-fixed">
              <QlikCard
                id="79797206-5b9b-4965-a419-5cdc6ca0666c"
                height="100px"
                showHeader={false}
                showMaximize={false}
                showExport={false}
                showOverlayer={false}
              />
            </div>
            <div className="filter-grow">
              <QlikCard
                id="AQJtJEQ"
                height="100%"
                showHeader={false}
                showMaximize={false}
                showExport={false}
                showOverlayer={false}
              />
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}